import Vue from 'vue'
import vuePerfectScrollbar from 'vue-perfect-scrollbar'
Vue.component('VuePerfectScrollbar', vuePerfectScrollbar)
